import React from 'react';
import { Box, Typography, Grid, Card, CardMedia, CardContent, useTheme } from '@mui/material';

const locations = [
  {
    title: 'Knox Aquatic Centre',
    image: 'images/SJ_Gallery/Knox_Pool.jpg',
    link: 'https://g.co/kgs/A3bg3sB',
  },
  {
    title: 'Aquabliss Pymble',
    image: 'images/SJ_Gallery/AQ_LTS_1.jpeg',
    link: 'https://g.co/kgs/JZqmw48',
  },
];

const Cards = () => {
  const theme = useTheme();

  return (
    <Box sx={{ textAlign: 'center', py: 4 , mr: 3, ml:3}}>
      {/* Section Title */}
      <Typography variant="h1" gutterBottom sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
        Our Locations
      </Typography>

      {/* Section Description */}
      <Typography variant="body1" sx={{ mb: 4, color: theme.palette.text.primary, maxWidth: '1000px', mx: 'auto' }}>
        Our swim club operates across different welcoming locations, each designed to provide a safe and enjoyable environment for swimmers of all levels. Whether you're just starting to learn or aiming to refine your technique, both of our pools offer the perfect setting for growth and fun in the water. Join us at these locations to experience expert coaching, a supportive community, and a great place to dive in and improve your skills.
      </Typography>

      {/* Grid for Cards */}
      <Grid container spacing={4} justifyContent="center">
        {locations.map((location, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              component="a"
              href={location.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* Card Image */}
              <CardMedia 
                component="img" 
                height="250" 
                image={location.image} 
                alt={location.title} 
                sx={{ 
                  borderRadius: 2, // Small rounded corners
                  boxShadow: 3,
                  objectFit: 'cover',
                  width: '100%', 
                  border: `3px solid ${theme.palette.primary.main}`, // Ensure image border is included
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  overflow: 'hidden', // Ensures the image stays inside
                  '&:hover': { 
                    transform: 'scale(1.05)', 
                    boxShadow: `0px 8px 20px ${theme.palette.primary.light}`
                  },
                }} 
              />

              {/* Card Content */}
              <CardContent sx={{ textAlign: 'center' }}>
                <Typography variant="h4" sx={{ color: theme.palette.primary.main}}>
                  {location.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Cards;
